export default {
  namespaced: true,
  bosch: {
    title: "Bosch",
    profiles: "Profiles",
    profile: "Profile",
    rules: "Rules",
    alarms: "Alarms",
    panels: "Panels",
    logs: "Logs",
    panel: "Panel",
    name: "Name",
    panelHost: "Panel Host",
    panelPasscode: "Panel Passcode",
    panelInstance: "Panel Instance",
    panelModel: "Panel Model",
    units: "Facilities",
    center: "Center",
    sector: "Sector",
    reseller: "Reseller",
    resellers: "Resellers",
    status: "Status",
    active: "Active",
    actions: "Actions",
    syncStatus: "Sync Status",
    syncActions: "Sync Actions",
    syncDevices: "Sync Devices",
    copyPassword: "Copy Password",
    syncing: "Syncing...",
    syncCorrectly: "Synced successfully",
    connected: "Connected",
    disconnected: "Disconnected",
    armPanel: "Arm Panel",
    disarmPanel: "Disarm Panel",
    arming: "Arming...",
    disarming: "Disarming...",
    armedCorrectly: "Armed successfully",
    disarmedCorrectly: "Disarmed successfully",
    description: "Description",
    deviceType: "Device Type",
    deviceId: "Device ID",
    area: "Area Name",
    areaId: "Area ID",
    eventType: "Event Type",
    userId: "User ID",
    username: "Username",
    alarmId: "Alarm ID",
    eventDate: "Event Date",
    devices: "Devices",
    panelOffline: "Panel Offline",
    panelStatusArmed: "Armed",
    panelStatusDisarmed: "Disarmed",
    panelStatusOffline: "Offline",
    eventDefinition: "Event Definition",
    eventCode: "Event Code",
    alarmType: "Alarm Type",
    typeAlarm: "Type Alarm",
    deviceName: "Device Name",
    dispatchAlarm: "Dispatch Alarm",
    wizard: {
      add: {
        title: "Add Bosch Panel"
      },
      edit: {
        title: "Edit Bosch Panel"
      },
      steps: {
        general: "General"
      }
    },
    messages: {
      areYouSure: "Are you sure to %action% %device_type% %device%?",
      commandExecutedSuccess: "Command %command% executed successfully",
      commandExecutedError: "Error executing command %command%",
      executeCommandConfirm: "Execute Command",
      processing: "Processing..."
    },
    devices: {
      devices: "Devices",
      update: "Update",
      error_loading_devices: "Error loading devices",
      retry: "Retry",
      panel_information: "Panel Information",
      areas: "Areas",
      zones: "Zones",
      outputs: "Outputs",
      doors: "Doors",
      no_devices_found: "No devices found",
      synchronize_panel_first: "Synchronize the panel first to see devices",
      area: "Area",
      zone: "Zone",
      output: "Output",
      door: "Door",
      panel: "Panel",
      arm: "Arm",
      disarm: "Disarm",
      bypass: "Bypass",
      reset: "Reset",
      open: "Open",
      close: "Close",
      activate: "Activate",
      deactivate: "Deactivate",
      actions_column: "ACTIONS",
      status_column: "STATUS",
      type_column: "TYPE",
      name_column: "NAME",
      device_id_column: "DEVICE ID",
      area_status: "Area Status",
      sync_devices: "Sync Devices",
      go_back: "Go Back"
    }
  }
}
